import { isAfter, isBefore, parseISO, isValid } from 'date-fns'
import { useEffect, useState } from 'react'

type ComparisonType = 'isBefore' | 'isAfter' | 'range'

const useDateCheck = (date: string, condition: ComparisonType, targetDate?: string): boolean => {
  const [isDateValid, setIsDateValid] = useState<boolean>(false)

  useEffect(() => {
    const now = new Date()
    const parsedDate = parseISO(date)

    if (!isValid(parsedDate)) {
      console.error('첫 번째 매개변수의 날짜 형식이 잘못되었습니다. 2000-01-01 형식으로 입력해주세요.')
      return
    }

    const conditionHandler: Record<ComparisonType, () => void> = {
      isAfter: () => setIsDateValid(isAfter(now, parsedDate)),
      isBefore: () => setIsDateValid(isBefore(now, parsedDate)),
      range: () => {
        if (targetDate) {
          const parsedComparisonDate = parseISO(targetDate)
          if (!isValid(parsedComparisonDate)) {
            console.error('날짜 형식이 맞지 않습니다. 2000-01-01 형식으로 입력해주세요.')
            return
          }
          setIsDateValid(isAfter(now, parsedDate) && isBefore(now, parsedComparisonDate))
        } else {
          console.error('범위 유형에 대한 비교 날짜가 누락되었습니다.')
        }
      },
    }

    const handler = conditionHandler[condition]
    if (handler) {
      handler()
    } else {
      console.error('두번째 매개변수의 값이 잘못되었습니다. "isBefore", "isAfter", "range" 중 하나를 입력해주세요.')
    }
  }, [date, condition, targetDate])

  return isDateValid
}

export default useDateCheck
